import React, { useState, useEffect } from "react";
import {
  Layout,
  Space,
  Spin,
  Menu,
  Dropdown,
  message as Mess,
  Tooltip
} from "antd";
import { DownOutlined, MessageOutlined, WhatsAppOutlined, SkypeOutlined, CloseOutlined } from "@ant-design/icons";
import TopBreadCrumb from "./breadcrumb";
// import TopMenu from "./topMenu";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import LeftMenu from "./leftMenu";
import axios from "common/axios";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import Switchs from "./switchs";
import ErrorPage from "../errorPage";
import UserDropDown from "./userDropDown";
import styles from "./index.module.less";
import getRouters from "../../routes";
import { observer } from "mobx-react";
import inject from "inject";

export default withRouter(
  observer((props) => {
    const [visiableApp, setVisiableApp] = useState(true);
    const { Header, Sider, Content } = Layout;
    const history = useHistory();
    const globalStore = inject("Base");
    const { pathname } = history.location;
    const relPathName = pathname?.substring(1); //去除开始的斜杠
    console.log(relPathName, "00000realpath");
    const { t } = useTranslation();
    const [lang, setLang] = useState("en");
    const [loading, setLoading] = useState(false);
    const checkoutLang = ({ key }) => {
      const check = key;
      i18n.changeLanguage(check);
      setLang(check);
      globalStore.setLang(check);
    };
    const [routesList, setRoutesList] = useState([]);
    const resourceId = async () => {
      setLoading(true);
      const { code, message, body } = await axios(`/biz/role/resource/tree`);
      setLoading(false);
      if (code !== 200) {
        Mess.error(message);
        return;
      }
      const { routers } = getRouters()[0];
      const result = [{
        title: "Tutorial",
        iconClassName: "ReadFilled",
        showSider: false,
        path: "/unifyDrop/Tutorial",
        component: () => import('./Tutorial/index')
      }, {
        title: "DashBoard",
        iconClassName: "DashboardFilled",
        showSider: true,
        path: "/unifyDrop/Summary",
        component: () => import('./summary/index')
      }];

      routers.forEach((td) => {
        const { children, title, ename } = td;
        const temp = body?.filter((ts) => ts.ename === title || ts.ename === ename)[0];
        if (temp) {
          result.push({
            ...td,
            children: filterChild(children, temp.childs),
          });
        }
      });

      setRoutesList(result);
    };
    const filterChild = (loclChild, child) => {
      const temp = loclChild.filter((td) => {
        const result = child?.find((ts) => ts.ename === td.title || ts.ename === td.ename);
        if (result) return td;
      });
      return temp;
    };
    const langMenu = (
      <Menu onClick={checkoutLang}>
        <Menu.Item key="zh">中文</Menu.Item>
        <Menu.Item key="en">English</Menu.Item>
      </Menu>
    );

    const [manSkype, setManSkype] = useState("");
    const [manWhatsApp, setManWhatsApp] = useState("");
    const getSalesManInfo = async () => {
      const { code, message, body } = await axios('biz/user/getSalesManInfo');
      if (code !== 200) {
        Mess.error(message);
        return;
      }
      setManSkype(body?.saleManSkype);
      setManWhatsApp(body?.saleManWhatsApp);
    }

    const goPage = () => {
      props.history.push("/unifyDrop/Tutorial");
    }

    useEffect(() => {
      resourceId();
      getSalesManInfo();
    }, []);
    return (
      <Spin spinning={loading}>
        <Header className={styles.topBar}>
          <h1 className={styles.logo}>
            <img alt="" src={require("../../images/logo2.png")} />
          </h1>
          
          <div className={styles.gis}>
            <Space>
              <UserDropDown {...props} />
            </Space>
            {/* <TopMenu {...props} /> */}
            <div className={styles.checkLang}>
              <Dropdown overlay={langMenu}>
                <a className="ant-dropdown-link">
                  {t(`${lang === "en" ? "English" : "中文"}`)} <DownOutlined />
                </a>
              </Dropdown>
            </div>
            <span onClick={() => goPage()} className={styles.tutorial}>Tutorial</span>
          </div>
        </Header>
        <Layout className={styles.main}>
          {["404", "403"].includes(relPathName) ? (
            <ErrorPage errorCode={relPathName} />
          ) : (
            <>
              <Sider className={styles.aside}>
                <LeftMenu {...props} routes={routesList} />
              </Sider>
              <Content className={styles.content} id="scroll-box">
                <TopBreadCrumb {...props} />
                <div id="scroll-container">
                  {/* <Card style={{ minHeight: "100%" }}> */}
                  <Switchs
                    {...props}
                    first={routesList[0]}
                    SubRoutes={routesList}
                  />
                  {/* </Card> */}
                </div>
              </Content>
            </>
          )}
        </Layout>
        <div className={styles.fix}>
          <div className={styles.appTip}>
            <Tooltip placement="left" title={!visiableApp ? 'Contact us' : 'Hide'} color="#fff" overlayClassName="whatTip">
              {!visiableApp && <MessageOutlined onClick={() => setVisiableApp(true)} />}
              {visiableApp && <CloseOutlined onClick={() => setVisiableApp(false)} />}
            </Tooltip>
          </div>
          {visiableApp ?
          <div>
            <div className={styles.Skype}>
              <a href={`skype:${manSkype}?Chat`}><SkypeOutlined /></a>
            </div>
            <div className={styles.WhataApp}>
              <a href={`https://api.whatsapp.com/send/?phone=${manWhatsApp}&text&type=phone_number&app_absent=0`} target="_blank"><WhatsAppOutlined /></a>
            </div>
          </div> : ''}
        </div>
      </Spin>
    );
  })
);
